export default __webpack_public_path__ + "static/media/CheckCaloriesAi2.8a41c59a.png";